import MapBuilder from "components/floorMap/MapBuilder";

export default function FloorMapBuilderPage() {
  return <MapBuilder />;
}
